module.exports = __webpack_public_path__ + "img/number4.9226f168.jpg";